import axiosInstance from "../axiosInstance";

export const emailToolApi = {
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/EmailTool${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err?.error ? err : err?.response?.data || err?.response || err;
      }),
  get: (path, params, headers, cancelToken) =>
    axiosInstance
      .get(`/EmailTool${path}`, {
        params,
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err?.error ? err : err?.response?.data || err?.response || err;
      }),
};

export const getEmailToolSettings = async () =>
  emailToolApi.get("/GetSettings/settings");

export const getEmailToolEmails = async (params) =>
  emailToolApi.get("/GetEmails", params);

export const getEmailToolEmail = async (id) =>
  emailToolApi.get(`/GetEmail/${id}`);

export const getEmailToolEmailLog = async (id, afterId = null) =>
  emailToolApi.get(`/GetEmailLog/${id}`, afterId ? { afterId } : undefined);

export const getEmailToolRecipients = async (params) =>
  emailToolApi.post("/GetRecipients/recipients", params);

export const sendEmailToolTest = async (params) =>
  emailToolApi.post("/SendTest", params);

export const saveEmailToolEmail = async (params) =>
  emailToolApi.post("/Save", params);
